import { makeStyles } from "../../_core/components";
import UIButton from "../../_core/components/ui/UIButton";
import UITypography from "../../_core/components/ui/UITypography";
import { usePoweredByLogo } from "../../brand/hooks";

const AuthFooter = () => {
  const classes = useStyles();
  const poweredByLogo = usePoweredByLogo();
  const hasRegister = false;
  return (
    <div className={classes.footer}>
      {hasRegister && (
        <div className={classes.registerCtr}>
          <UITypography variant="body2" className={classes.registerText}>
            Not registered yet?
          </UITypography>
          <UIButton variant="text" to="/register">
            Register Now
          </UIButton>
        </div>
      )}
      {Boolean(poweredByLogo) && (
        <div className={classes.poweredByCtr}>
          <img alt="powered-by-logo" src={poweredByLogo} />
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  footer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 100,
  },
  poweredByCtr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    height: 140,
    "& > img": {
      display: "block",
      height: 60,
      objectFit: "contain",
    },
  },
  registerCtr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingBottom: theme.spacing(5),
  },
  registerText: {
    paddingTop: theme.spacing(1),
  },
}));

export default AuthFooter;
